import { useState } from "react";
import { api } from "../../../shared/api/client";
import { toast } from "../../../shared/stores/toasts";

export function AdminKms() {
  const [result, setResult] = useState<Record<string, number> | null>(null);
  const [running, setRunning] = useState(false);
  const run = async () => {
    if (!confirm("PII 컬럼 전체를 새 키로 재암호화합니다. 진행하시겠습니까?")) return;
    setRunning(true);
    try {
      const r = await api.post<Record<string, number>>("/admin/kms/rotate");
      setResult(r.data); toast.success("KMS 회전 완료");
    } catch (e: any) {
      toast.error("회전 실패", e?.response?.data?.error?.message);
    } finally { setRunning(false); }
  };
  return (
    <div className="t-grid cols-1">
      <div className="t-card">
        <h3 style={{ margin: "0 0 8px" }}>KMS 키 회전</h3>
        <p style={{ fontSize: 13, color: "var(--text-3)", marginTop: 0 }}>
          모든 PII 컬럼 (주민번호 · 계좌번호 · 기본급 · 법인카드 · MFA secret)을 현재 키로 재암호화합니다.
          이전 키는 <code>KMS_PREVIOUS_KEYS</code> 환경변수에 유지되어 진행 중 복호화가 가능합니다.
        </p>
        <button className="t-btn t-btn-primary" onClick={run} disabled={running}>{running ? "회전 중…" : "지금 회전"}</button>
      </div>
      {result && (
        <div className="t-card">
          <h3 style={{ margin: "0 0 8px" }}>회전 결과</h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
            {Object.entries(result).map(([k, v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid var(--border)" }}>
                <span className="mono" style={{ fontSize: 12 }}>{k}</span>
                <span className="num" style={{ fontWeight: 700 }}>{v}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
